import { useState } from 'react';

export function ShareButton() {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2500);
      })
      .catch(() => {
        // Fallback for browsers that don't support clipboard API
        const input = document.createElement('input');
        input.value = window.location.href;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        setCopied(true);
        setTimeout(() => setCopied(false), 2500);
      });
  }

  return (
    <button
      onClick={handleCopy}
      className="
        inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border-2 border-brand/20
        text-brand font-medium text-sm
        hover:border-brand/40 hover:bg-porcelain
        focus:outline-none focus:ring-2 focus:ring-scarlet/40 focus:ring-offset-2
        transition-all duration-150
      "
    >
      <span aria-hidden>{copied ? '✓' : '🔗'}</span>
      {copied ? 'Link copied!' : 'Share results'}
    </button>
  );
}
